import { render, staticRenderFns } from "./SecurityLogo.vue?vue&type=template&id=38b0d7e0&scoped=true&"
import script from "./SecurityLogo.vue?vue&type=script&lang=js&"
export * from "./SecurityLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b0d7e0",
  null
  
)

export default component.exports